import EmailVerifyPresenter from './EmailVerifyPresenter';
import { useEffect, useState } from 'react';
import { ActionCompleteResponse } from 'common/types/ApiResponse';
import useApi from 'common/hooks/useApi';
import { UserEmail } from './UserEmail';
import SecurtiyQuestionsPresenter from './SecurityQuestionsPresenter';
import { QuestionsList } from './QuestionsList';
import { ResetPassword } from './ResetPassword';
import { ResetPassForm } from './ResetPassForm';
import { Route, Switch, useHistory } from 'react-router';
import { isActionCompleteSuccess } from 'common/services/api/isActionCompleteSuccess';
import AlertType from 'common/types/AlertType';
import {Redirect} from "react-router-dom";
const MySwitch = Switch as any;
const MyRoute = Route as any;
const MyRedirect = Redirect as any;

function ForgotPasswordContainer() {
  const [emailVerified, setEmailVerified] = useState(false);
  const [email, setEmail] = useState('');
  const history = useHistory();

  const [profileReturn, profileRequest] = useApi<ActionCompleteResponse>({
    url: '/profile/user/exists',
    method: 'POST',
    bypassTokenCheck: true,
  });

  const handleEmailSubmit = async (values: UserEmail) => {
    await profileRequest(values);
    setEmail(values.email);
  };

  const [questionsReturn, questionsRequest] = useApi<QuestionsList>({
    url: `/profile/getQuestForUser?email=${encodeURIComponent(email)}`,
    method: 'GET',
    bypassTokenCheck: true,
  });

  const [resetPassReturn, resetPassRequest] = useApi<ActionCompleteResponse>({
    url: '/profile/resetPassword',
    method: 'PUT',
    bypassTokenCheck: true,
  });

  const handleQuestionsAnswerSubmit = async (values: ResetPassForm) => {
    if (!questionsReturn.data) {
      return;
    }

    const { data } = await resetPassRequest<ResetPassword>({
      email,
      questions: [
        {
          id: questionsReturn.data.questions[0].id,
          question: questionsReturn.data.questions[0].question,
          answer: values.answer0,
        },
        {
          id: questionsReturn.data.questions[1].id,
          question: questionsReturn.data.questions[1].question,
          answer: values.answer1,
        },
        {
          id: questionsReturn.data.questions[2].id,
          question: questionsReturn.data.questions[2].question,
          answer: values.answer2,
        },
      ],
    });

    if (isActionCompleteSuccess(data)) {
      history.push('/auth/login', {
        message:
          'Please check the email associated with this account for your temporary password. It may take up to 30 minutes for this email to send.',
        type: AlertType.success,
      });
    }
  };

  useEffect(() => {
    if (
      profileReturn.data?.payload &&
      profileReturn.data.payload.responseCode === 'SUCCESS'
    ) {
      setEmailVerified(true);
    }
    if (email) {
      questionsRequest();
    }
  }, [profileReturn, questionsRequest, email]);

  return (
    <MySwitch>
      {!emailVerified && (
        <MyRoute>
          <EmailVerifyPresenter
            error={profileReturn.error}
            onSubmit={handleEmailSubmit}
            submitting={profileReturn.loading}
          />
        </MyRoute>
      )}
      {emailVerified && (
        <MyRoute>
          <SecurtiyQuestionsPresenter
            data={questionsReturn.data}
            questionsError={questionsReturn.error}
            answerSubmitResponse={resetPassReturn.data}
            onSubmit={handleQuestionsAnswerSubmit}
            submitting={resetPassReturn.loading}
          />
        </MyRoute>
      )}
    </MySwitch>
  );
}

export default ForgotPasswordContainer;
